import { BaseServices, HttpMethod } from '@services/base'
import { TipoDocs } from '@store/refinanciamento/listaDocumentos/types'

export default async (accessToken?: string) => {
  const pathname = process.env.REACT_APP_GET_DOCUMENTOS_ASSINATURA
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
  }

  const response = await BaseServices.request<DocumentoAssinaturaRequest>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}

export interface DocumentoAssinaturaItem {
  idDocumento?: string
  idTipoDocumento: TipoDocs
  nomeTipoDocumento?: string
  status?: string
  isDone?: boolean
}

export interface DocumentoAssinaturaRequest {
  idInteracao: string
  numeroProposta: string
  pendentes: DocumentoAssinaturaItem[]
  enviados: DocumentoAssinaturaItem[]
}
